import {
    setAppState,
    setAppError,
    metaUpdate,
} from "../../actions/App/dispatchers";
import { fetch_topic_gql } from "../../actions/Topic/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import { fetchAllKeyValues } from "../../fetch/graphql/requests/keyValues";
import { formatTopicHeading, getTopicHeading } from "./utils";
import { PAGE_TYPES } from "../../constants/tracking";

export const fetchTopicPageData = (path, params) => (dispatch) => {
    const { kind, keywords } = params;

    dispatch(reset_app_state(path));
    dispatch(reset_right_rail());

    return dispatch(fetch_topic_gql({ kind, keywords }))
        .then(async () => {
            try {
                return await fetchAllKeyValues("ocelot.topic.*");
            } catch (error) {
                return Promise.resolve({});
            }
        })
        .then((tracking) => {
            const keyValues = tracking?.allKeyValues?.nodes.find(
                (kv) =>
                    kv.key ===
                    `ocelot.topic.${path.substr(1).replace(/\./g, "")}`
            );
            if (keyValues) {
                tracking = keyValues.value;
            }

            return dispatch(fetch_tracking(tracking, false));
        })
        .then(() => dispatch(setAppState(path, false, "")))
        .then(() =>
            dispatch((dispatch, getState) => {
                const state = getState();
                const title = formatTopicHeading(getTopicHeading(path));
                const pageTitle = `${title} | CBC.ca`;
                dispatch(
                    metaUpdate(
                        title,
                        {
                            ...state?.app?.meta,
                            "og:title": pageTitle,
                            "twitter:title": pageTitle,
                        },
                        PAGE_TYPES.TOPIC
                    )
                );
            })
        )
        .catch((error) => {
            dispatch(setAppError(path, error.code));
        });
};
